document.addEventListener('DOMContentLoaded', () => {
  const currentMediaQuery = Foundation.MediaQuery.current;

  if (currentMediaQuery === 'small' || currentMediaQuery === 'medium') {
    // Remove 'full-width' class from header elements
    const headerFullWidthElements = document.querySelectorAll('header .full-width');
    headerFullWidthElements.forEach((element) => {
      element.classList.remove('full-width');
    });
  }
});
